import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { createMuiTheme } from '@material-ui/core/styles';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ThemeProvider } from '@material-ui/styles';
import * as actions from '../../Actions/bankfeeds';
import css from './login.css';
import ReckonLogo from './logo-icon.png';

class LoginForm extends React.Component {
  submit = values => {
    this.props.change("error", "");
    if (values.username === undefined) {
      throw new SubmissionError({
        username: "Please fill in your Email"
      });
    }
    if (values.password === undefined) {
      throw new SubmissionError({
        password: "Please fill in your Password"
      });
    }
    this.props.login(values.username, values.password);
  };

  renderTextField = ({
    input,
    label,
    id,
    meta: { touched, error },
    ...custom
  }) => (
    <div className={css.pb10}>
      {id === "email" ? (
        <MailOutlineIcon className={css.icon} />
      ) : (
        <LockOpenIcon className={css.icon} />
      )}
      <TextField
        style={{ width: "80%" }}
        placeholder={label}
        {...input}
        {...custom}
      />
      <div className={css.error}>{touched && error}</div>
    </div>
  );

  render() {
    const {
      onToggle,
      handleSubmit,
      pristine,
      submitting,
      xpa
    } = this.props;

    const theme = createMuiTheme({
      palette: {
        primary: { main: "#262626" },
        secondary: { main: "#00bd9d" }
      },
      overrides: {
        MuiFormControlLabel: {
          label: {
            color: "grey",
            fontSize: 15
          }
        },
        MuiButton: {
          containedPrimary: {
            fontWeight: "bold"
          },
          containedSecondary: {
            color: "white",
            fontWeight: "bold"
          }
        }
      }
    });

    let buttonInfo = "Sign in";
    if (xpa.loggingIn) buttonInfo = <CircularProgress size={24} />;

    return (
      <React.Fragment>
        <ThemeProvider theme={theme}>
          <img src={ReckonLogo} className={css.avatar} />
          <Typography component="h1" variant="h5">
            Sign in to Reckon Bankdata
          </Typography>
          <form className={css.form} onSubmit={handleSubmit(this.submit)}>
            <div>
              <Field
                component={this.renderTextField}
                margin="normal"
                id="email"
                name="username"
                label="Email"
                autoFocus
              />
              <Field
                component={this.renderTextField}
                margin="normal"
                id="password"
                fullWidth
                name="password"
                label="Password"
                type="password"
              />
              {xpa.loginError && (
                <div className={css.error}>
                  {`Login Failed, check your email and password`}
                </div>
              )}
            </div>
            <div className={css.pl35}>
              <div className={[css.pr30, css.pt20].join(" ")}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="secondary"
                  disabled={pristine || submitting}
                >
                  {buttonInfo}
                </Button>
                <p className={css.link} onClick={onToggle}>
                  {/* "Help, I forgot my sign in details" */}
                </p>
                <p className={css.terms}>
                  &copy; Copyright 2020{" "}
                  <span className={css.company}>Reckon Ltd.</span> All Rights
                  Reserved.
                </p>
              </div>
            </div>
          </form>
        </ThemeProvider>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { xpa } = state;
  return { xpa };
}

LoginForm = connect(
  mapStateToProps,
  actions
)(
  reduxForm({
    form: "login"
  })(LoginForm)
);

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/Portal/LoginForm.js